export default __webpack_public_path__ + "images/composite-index-icon2.png";